import React from "react"
export function Voucher(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M8.053 2c0 1.105.873 2 1.95 2s1.95-.895 1.95-2h3.55a1 1 0 011 1v14a1 1 0 01-1 1h-3.55c0-1.105-.873-2-1.95-2s-1.95.895-1.95 2h-3.55a1 1 0 01-1-1V3a1 1 0 011-1h3.55zM6.886 3.5H5.003L5.002 8.66h2.354v2H5.002v5.838h1.885l.05-.104a3.445 3.445 0 012.876-1.89l.19-.005c1.34 0 2.494.772 3.066 1.895l.05.104h1.884l-.001-5.838h-2.313v-2h2.313V3.499H13.12l-.05.106a3.445 3.445 0 01-2.876 1.89l-.19.005a3.442 3.442 0 01-3.067-1.895l-.05-.106zm4.47 5.162v2H8.689v-2h2.667z"
        fill="currentColor"
        fillRule="nonzero"
        id="prefix__voucher"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
